<template>
  <section-container>
    <header-page
      title_header="Assinatura"
      sub_header="Selecione seu plano para começar a vender"
    />
    <content-e>
      <div class="w-full flex flex-wrap bg-white shadow-2l p-6">
        <form
          id="payment-form"
          class="mx-auto bg-white shadow-2l w-full lg:w-2/4 p-2"
        >
          <!-- Stripe Elements Placeholder -->
          <div id="card-element"></div>

          <button id="card-button" type="button">Assinar</button>
        </form>
      </div>
    </content-e>
  </section-container>
</template>

<script>
export default {
  data() {
    return {
      stripe: null,
      stripe_pub: process.env.VUE_APP_STRIPE_PUB,
      intentToken: '',
      paymentMethod: ''
    }
  },
  methods: {
    createPaymentSecret() {},
    submitPaymentMethod() {
      this.$store.dispatch('PAYMENT_METHOD')
    },
    loadScript: () => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.onload = () => {
          resolve(true)
        }
        script.async = true
        script.src = 'https://js.stripe.com/v3/'
        document.head.appendChild(script)
      })
    }
  },
  async beforeMount() {},
  async mounted() {
    await this.loadScript()
    this.stripe = window.Stripe(this.stripe_pub)

    const elements = this.stripe.elements()
    const cardElement = elements.create('card')

    cardElement.mount('#card-element')

    const cardButton = document.getElementById('card-button')

    this.$store.dispatch('SETUP_INTENT').then((response) => {
      this.intentToken = response.data
    })

    cardButton.addEventListener('click', async (e) => {
      const { setupIntent, error } = await this.stripe.confirmCardSetup(
        this.intentToken.client_secret,
        {
          payment_method: {
            card: cardElement
          }
        }
      )
      if (!error) {
        await this.$store.dispatch('PAYMENT_METHOD', {
          payment_method: setupIntent.payment_method
        })
        this.$store
          .dispatch('SUBSCRIPTION', {
            plan: this.$route.params.plan
          })
          .then((response) => {
            this.$toasted.success('Assinatura ativada com sucesso!', {
              position: 'top-center',
              duration: 5000,
              icon: 'check'
            })
            this.$router.push({ name: 'subscription.my' })
          })
      }
      return false
    })
  }
}
</script>

<style>
</style>
